module.exports = __webpack_public_path__ + "img/Kibe62.1b620e12.jpg";